/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EUICCCAPABILITIES } from './eUICCCAPABILITIES';


export interface EISSHORT {
    /**
     * eUICC-ID
     */
    eid: string;
    /**
     * eUICC Manufacturer ID
     */
    eumId: string;
    productionDate: string;
    platformType: string;
    platformVersion: string;
    remainingMemory: number;
    availableForProfiles: number;
    lastAuditDate?: string;
    /**
     * ID of SM-SR instance
     */
    smsrId: string;
    /**
     * ISDP Load file AID
     */
    isdpLoadfileAid: string;
    /**
     * ISDP Module AID
     */
    isdpModuleAid: string;
    euiccCapabilities: EUICCCAPABILITIES;
    eumCertificateId: string;
    signatureAlgorithm: EISSHORT.SignatureAlgorithmEnum;
    signature: string;
    cardGroup?: number;
}
export namespace EISSHORT {
    export type SignatureAlgorithmEnum = 'RSA_SHA256' | 'RSA_SHA384' | 'RSA_SHA512' | 'ECDSA_SHA256' | 'ECDSA_SHA384' | 'ECDSA_SHA512';
    export const SignatureAlgorithmEnum = {
        RSASHA256: 'RSA_SHA256' as SignatureAlgorithmEnum,
        RSASHA384: 'RSA_SHA384' as SignatureAlgorithmEnum,
        RSASHA512: 'RSA_SHA512' as SignatureAlgorithmEnum,
        ECDSASHA256: 'ECDSA_SHA256' as SignatureAlgorithmEnum,
        ECDSASHA384: 'ECDSA_SHA384' as SignatureAlgorithmEnum,
        ECDSASHA512: 'ECDSA_SHA512' as SignatureAlgorithmEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/eISSHORT.ts